import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Const} from '../const/const';
import {Observable} from 'rxjs';
import {JobAd} from '../models/job-ad.model';

@Injectable({
  providedIn: 'root'
})
export class JobAdService {
    constructor(private http: HttpClient) {}

    applyJobAd(data: any): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/apply-job-ad', data);
    }

    applyDemoJobAd(data: any): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/apply-demo-job-ad', data);
    }

    checkApplied(jobAdId: number) {
        return this.http.get(Const.baseAPI + '/check-applied/' + jobAdId);
    }

    findJobs(data: any): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/find-jobs?language=' + data.language + '&permanentTemporary=' + data.permanentTemporary +
                                        '&workTime=' + data.workTime + '&cities=' + data.cities + '&country=' + data.country + '&fieldWork=' + data.fieldWork +
                                        '&itemsPerPage=' + data.itemsPerPage + '&start=' + data.start + '&user_id=' + data.user_id + '&checkJobSeeker=' + data.checkJobSeeker);
    }

    getNumberJobEachField() {
        return this.http.get(Const.baseAPI + '/get-number-job-each-field');
    }

    findJobById(id: number, type: string, user_id: number = null, currentLang: string = null): Observable<JobAd> {
        return this.http.get<JobAd>(Const.baseAPI + '/find-job-by-id/' + id  + '/' + type + '/' + user_id + '/' + currentLang);
    }

    findJobByKeyword(data: any): Observable<any> {
      return this.http.get<any>(`${Const.baseAPI}/find-jobs-by-keyword?keyword=` + data.searchKeyword + '&itemsPerPage=' + data.itemsPerPage + '&start=' + data.start + '&user_id=' + data.user_id + '&checkJobSeeker=' + data.checkJobSeeker);
    }

    listJobAds(): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/list-job-ads');
    }

    getAllJobAds(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-ads/' + index + '/' + numberItem);
    }

    getAllJobApproval(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-approval/' + index + '/' + numberItem);
    }

    getAllJobAwaitingApproval(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-awaiting-approval/' + index + '/' + numberItem);
    }

    getAllJobReject(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-reject/' + index + '/' + numberItem);
    }

    getAllJobExpired(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-expired/' + index + '/' + numberItem);
    }

    getAllJobClose(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-close/' + index + '/' + numberItem);
    }

    getAllJobTest(index: number, numberItem: number): Observable<JobAd[]> {
        return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-test/' + index + '/' + numberItem);
    }

    getAllJobCancel(index: number, numberItem: number): Observable<JobAd[]> {
      return this.http.get<JobAd[]>(Const.baseAPI + '/get-all-job-cancel/' + index + '/' + numberItem);
    }

    deleteJobAd(jobAdId: number): Observable<void> {
        return this.http.delete<void>(Const.baseAPI + '/del-job-ad/' + jobAdId);
    }

    cancelJobAd(jobAdId: number): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/cancel-job-ad/' + jobAdId, null);
    }

    completeJobAd(jobAdId: number): Observable<void> {
      return this.http.post<void>(Const.baseAPI + '/complete-job-ad/' + jobAdId, null);
    }

    approvalJobAd(data): Observable<void> {
        return this.http.post<any>(Const.baseAPI + '/approval-job-ad', data);
    }

    updateProlongAd(data): Observable<void> {
        return this.http.post<any>(Const.baseAPI + '/prolong-job-ad', data);
    }

    getJobFree(index: number, numberItem: number): Observable<JobAd[]> {
      return this.http.get<JobAd[]>(Const.baseAPI + '/get-job-free/' + index + '/' + numberItem);
    }

    getJobPublicationFees(index: number, numberItem: number): Observable<JobAd[]> {
      return this.http.get<JobAd[]>(Const.baseAPI + '/get-job-publication-fees/' + index + '/' + numberItem);
    }

    getJobProlongation(index: number, numberItem: number): Observable<JobAd[]> {
      return this.http.get<JobAd[]>(Const.baseAPI + '/get-job-prolongation/' + index + '/' + numberItem);
    }

    updateCheckboxInvoice(data: any): Observable<void> {
      return this.http.post<void>(Const.baseAPI + '/update-checkbox-invoice', data);
    }
}
